export default {
	'aviation':'local_airport',
	'ecological':'local_florist',
	'transportation':'directions_railway',
	'historical':'vpn_key',
	'hazard':'report',
	'regulatory':'gavel',
	'economic':'local_atm'
}


// WEBPACK FOOTER //
// ./src/config/overlay-icons.js